//#region src/urls.ts
/** Public n8n pricing page — the upgrade destination for non-cloud deployments. */
const N8N_PRICING_PAGE_URL = "https://n8n.io/pricing";

//#endregion
export { N8N_PRICING_PAGE_URL };
//# sourceMappingURL=urls.mjs.map